import {
    ITopicHeaders,
    MessageBroker,
    PostLoginActionNameEnum,
    PlayerChannel,
} from '@sparkware/uc-sdk-core';
import { IPostLoginActionsState } from '../models/IPostLoginActionsState';
import { PostLoginActionBase } from './post-login-action-base';

const MB_HEADER: ITopicHeaders = { publisher: 'OpenAccountSummaryPostLoginAction' };

export class OpenAccountSummaryPostLoginAction extends PostLoginActionBase {
    private _playerChannel: PlayerChannel;

    constructor(state: IPostLoginActionsState) {
        super(
            PostLoginActionNameEnum.ShowAccountSummaryPage,
            'OpenAccountSummaryPostLoginAction',
            state,
        );
        this._playerChannel = MessageBroker.getInstance().player;
    }

    protected override doAction = async (): Promise<boolean> => {
        this._playerChannel.topics.CTA_MyAccount_Open.publish(MB_HEADER, {
            tabId: 6,
            onClose: this.completeAction,
            hideHeader: false,
            hideMenu: false,
        });
        return false;
    };
}
